// extracted by mini-css-extract-plugin
export var formContainer = "LocalChangeEnrollmentForm-module--formContainer--1ujRP";
export var Card = "LocalChangeEnrollmentForm-module--Card--4-nha";
export var formButtonContainer = "LocalChangeEnrollmentForm-module--formButtonContainer--3smkx";
export var selectContainer = "LocalChangeEnrollmentForm-module--selectContainer--25Kdr";
export var fieldsContainer = "LocalChangeEnrollmentForm-module--fieldsContainer--osIV-";
export var fieldWrapper = "LocalChangeEnrollmentForm-module--fieldWrapper--1B5Rq";